<template>
    <div
        v-if="segments.length"
        class="bg-dark-lightest flex w-full gap-px overflow-hidden rounded-full"
        :class="height"
        role="img"
        :aria-label="label"
    >
        <div
            v-for="(segment, index) in segments"
            :key="`gait-segment-${index}`"
            :style="{ width: `${segment.percent}%`, backgroundColor: segment.color }"
            :title="segment.text"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import tailwind from '@/lib/tailwind'
import { secondsToHMS } from '@/lib/helpers/convert'
import { gaitBarSegments } from '@/lib/protocol-steps'

const props = defineProps({
    // Ordered [{ gait: 'walk' | 'trot' | 'canter' | 'standing', duration: seconds }]:
    // drawn in order, so the bar reads as the step's timeline.
    gaits: { type: Array, default: () => [] },
    height: { type: String, default: 'h-2.5' },
})

const { t } = useI18n()
const gaitColors = tailwind.theme.color.gaits

const segments = computed(() =>
    gaitBarSegments(props.gaits).map((segment) => ({
        ...segment,
        color: gaitColors?.[segment.gait] || gaitColors?.all,
        text: [segment.gait ? t(`gait.${segment.gait}`) : null, secondsToHMS(segment.duration, 2, true)]
            .filter(Boolean)
            .join(' '),
    }))
)

const label = computed(() => segments.value.map((segment) => segment.text).join(', '))
</script>
